module.exports = __webpack_public_path__ + "img/finis.8c1f290a.png";